import { MainPage } from './main_page'

export default MainPage
